jQuery.extend(jQuery.fn.dataTableExt.oSort, {
    "num-html-pre": function (a) {
        var x = String(a).replace(/<[\s\S]*?>/g, "");
        return parseFloat(x);
    },

    "num-html-asc": function (a, b) {
        return ((a < b) ? -1 : ((a > b) ? 1 : 0));
    },

    "num-html-desc": function (a, b) {
        return ((a < b) ? 1 : ((a > b) ? -1 : 0));
    }
});

// use this when allowing datatables to call the web service directly 
// instead of calling web service and manually loading data into datatable 
// this is useful when using server side paging 
// to use, on dt options, set ajax using an object with url, data,  
// and set dataType to "datatables-asmxjson" 
$.ajaxPrefilter("datatables-asmxjson", function (options, originalOptions, jqXHR) {
    // Modify options, control originalOptions, store jqXHR, etc 
    options.type = "POST";
    options.dataType = "json";
    options.contentType = 'application/json; charset=utf-8';
    options.data = JSON.stringify(originalOptions.data);
}); 
